import { RouteConfig } from 'vue-router';

export const routes: RouteConfig[] = [];
